import React from "react";
import EmptyDataView from "../nodataview";
import icon from "../../assets/images/no-service.png";
import "./sidebar.scss";
const EmptyHistory = () => {
  return (
    <div className="EmptyHistory">
      <EmptyDataView
        className="empty-data-view-container"
        Icon={
          <img className="users-card-icon-img" src={icon} alt="Users Icon" />
        }
        Header={"No Changes Have Been Made"}
        Description={
          "This Panel will populate with any saved changes for this specific module."
        }
      />
    </div>
  );
};

export default EmptyHistory;
